import { CircularProgress } from '@mui/material';
import React from 'react';

const DataLoaderProgressBar: React.FC = () => {
    return (
        <div>
            <CircularProgress
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-20px',
                    marginLeft: '-20px',
                    color: '#06b3cf',
                }}
            />
        </div>
    );
};

export default DataLoaderProgressBar;
